var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SpForm',{ref:"form",staticClass:"content_part-nav-setting",attrs:{"suffix":"","formList":_vm.navFormList,"submit":false,"labelWidth":"80px"},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }